<template>
  <div id="app" :class="getTheme" class="portal">
    <AppMain />
    <CookieMessage />
  </div>
</template>

<script>
import PortalHeader from '@/layout/PortalHeader/PortalHeader.vue'
import PortalFooter from '@/layout/PortalFooter/PortalFooter.vue'
import CookieMessage from '@/layout/CookieMessage/CookieMessage.vue'
import AppMain from '@/layout/AppMain.vue'

export default {
  components: { PortalHeader, AppMain, PortalFooter, CookieMessage },
  computed: {
    sidebar () {
      return this.$store.getters['layout/getSidebar']
    },
    getTheme () {
      return this.$store.getters['layout/getTheme']
    }
  },
  methods: {
    portalMode () {
      console.log('parametro:' + this.$route.query.portal)
      return this.$route.query.portal === 'true'
    }
  }
}
</script>
